import React, { ReactNode, useContext, useMemo, useState } from 'react';

interface ContextValue {
    setBanner: (node: ReactNode) => void;
    banner?: ReactNode;
}

const BannerContext = React.createContext<ContextValue | null>(null);

interface ProviderProps {
    children: ReactNode;
}

export const BannerProvider = ({ children }: ProviderProps) => {
    const [banner, setBanner] = useState<ReactNode>();

    // useMemo required - context value passed to provider.
    // React Compiler doesn't optimize context values automatically.
    const contextValue = useMemo(() => ({ banner, setBanner }), [banner]);

    return <BannerContext.Provider value={contextValue}>{children}</BannerContext.Provider>;
};

export function useBanner() {
    const ctx = useContext(BannerContext);
    if (!ctx) {
        throw new Error('Banner provider is not detected');
    }
    return ctx;
}
